// import React, { Component } from 'react';
import Tools from '../../../tools.js';
import API from '../../../api';
import React, { useState, useEffect } from "react";
// import './App.css';
import QuestSkipApp from './QuestSkipApp';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useMappedState, useDispatch } from 'redux-react-hook';

export default function QuestSkipCustApp(props) {
    const [isFetched, setIsFetched] = useState(false);
    const [isInit, setIsInit] = useState(false);
    const [pi, setPi] = useState(props.pi || "");
    const items = useMappedState(state => state.items);
    const tmpItems = useMappedState(state => state.tmpItems);
    const dispatch = useDispatch();

    useEffect(() => {
        if (false == isFetched) {
            Tools.init();
            getData(onDataUpdated);
        }
        setIsFetched(true);
    }, [isFetched]);

    function getData() {
        var tmpData = {
            pi: pi
        };
        API.GetQuestionnaire(tmpData).
            then(onDataUpdated);
    }

    function onCopy(index) {
        let tmp = [...tmpItems];
        // console.log(tmp);
        let newItem = JSON.parse(JSON.stringify(tmp[index]));
        tmp.splice(index, 0, newItem);
        for (let i = 0; i < tmp.length; i++) {
            tmp[i].id = "item-" + i
        }
        // console.log(newItem, tmp);
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
    }

    function onRemove(index) {
        let tmp = [...tmpItems];
        tmp.splice(index, 1);
        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
    }

    function onSaveAndBack() {
        // console.log(tmpItems);
        var tmpData = {
            pi: pi,
            ty: 0 //(items == null || 0 == items.length) ? 0 : 1
        };
        API.AddQuestionnaire(tmpData, tmpItems).
            then(checkResult).
            then(props.onBackToList);
    }

    function onNext() {
        // console.log(tmpItems);
        var tmpData = {
            pi: pi,
            ty: 0 //(items == null || 0 == items.length) ? 0 : 1
        };
        API.AddQuestionnaire(tmpData, tmpItems).
            then(checkResult).
            then(props.onNextStep);
    }

    function checkResult(data) {
        // console.log(data);

        if (data && data.responseData) {
            try {
                alert(data.responseData.msg);
                if (data.responseData.code == "22000") {
                    getData();
                }
            } catch (e) {
                alert("update error");
                console.warn(e.stack);
            }
        }
    }

    function onDataUpdated(data) {
        // console.log(data);
        // setItem(tmp);

        if (data && data.response
            && data.response.status == 200 && data.responseData) {
            dispatch({ type: "UPDATE_ITEM", data: { pid: pi, items: data.responseData } });
        } else {
            dispatch({ type: "UPDATE_ITEM", data: { pid: pi, items: [] } });
        }
        setIsInit(true);
    }

    function render() {
        if (null == items) {
            if (isInit == true) {
                return <div>No Data</div>
            }
            return <div>loading...</div>
        } else {
            return (
                <Container className="App mb-50">
                    <QuestSkipApp onRemove={onRemove} onCopy={onCopy} onSaveAndBack={onSaveAndBack} onNext={onNext}></QuestSkipApp>
                </Container>
            );
        }
    }
    return render();
}
